/* src/app/components/dialogs/manage-defaults/manage-defaults.component.scss */
mat-dialog-content {
  margin-top: 24px;
  margin-bottom: 24px;
  padding: 12px 24px 0px 24px;
  min-width: 200px;
  min-height: 50px;
}
mat-form-field {
  margin-left: 12px;
}
td {
  padding-right: 5px;
  padding-left: 5px;
}
td:first-child {
  text-align: left;
}
/*# sourceMappingURL=manage-defaults.component.css.map */
